import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CookiePolicyComponent } from './sites/cookie-policy/cookie-policy.component';
import { LandingPageComponent } from './sites/landing-page/landing-page.component';
import { MaintanceGuard } from './components/maintenance/maintenance.guard';
import { DefaultLayoutComponent } from './layouts/default-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout.component';
import { HouseRulesComponent } from './sites/house-rules/house-rules.component';
import { BookingPageComponent } from './sites/booking-page/booking-page.component';
import { GalleryPageComponent } from './sites/gallery-page/gallery-page.component';
import { AboutUsPageComponent } from './sites/about-us-page/about-us-page.component';
import { RegionPageComponent } from './sites/region-page/region-page.component';

const routes: Routes = [
  { path: '',
    component: DefaultLayoutComponent,
    canActivate: [MaintanceGuard],
    children: [
      { path: '', component: LandingPageComponent},
      { path: 'rolunk', component: AboutUsPageComponent},
      { path: 'kornyek', component: RegionPageComponent},
      //{ path: 'foglalas', component: BookingPageComponent},
      { path: 'galeria', component: GalleryPageComponent},
      /*{ path: 'hazirend', component: HouseRulesComponent},
      { path: 'sutikezelesi-szabalyzat', component: CookiePolicyComponent},
      { path: 'adatvedelmi-tajekoztato', component: CookiePolicyComponent},*/
    ]
  },

  
  { path: '',
    component: BlankLayoutComponent,
    children: [
      { path: 'karbantartas', loadChildren: () => import('./components/maintenance/maintenance.module').then(m => m.MaintenanceModule) },
  
    ]
  },

  { path: '**', redirectTo: '', pathMatch: 'full' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'top', scrollOffset: [0, 160]})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
